
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"241.23 120.615 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M577.229 568.615c8.832 0 16-7.168 16-16v-192c0-8.832-7.168-16-16-16-8.831 0-15.999 7.167-15.999 16v192c0 8.832 7.167 16 15.999 16zm96-384h-96v-32c0-17.68-14.32-32-32-32H449.23c-17.681 0-32.001 14.32-32.001 32v32H321.23c-17.68 0-32 14.32-32 32v32c0 17.664 14.32 32 32 32v288c0 35.344 28.656 64 64 64h224c35.344 0 64-28.656 64-64v-288c17.68 0 32-14.336 32-32v-32.001c-.001-17.678-14.321-31.999-32.001-31.999zm-223.999-16c0-8.832 7.167-16 15.999-16h64c8.832 0 16 7.168 16 16v16H449.23v-16zm191.999 400c0 17.664-14.319 32-31.999 32h-224c-17.681 0-32.001-14.336-32.001-32v-288h288v288zm16-319.999h-320c-8.832 0-16-7.168-16-16s7.168-16 16-16h320c8.832 0 16 7.168 16 16s-7.167 16-16 16zm-240 319.999c8.832 0 16.001-7.168 16.001-16v-192c0-8.832-7.168-16-16.001-16-8.832 0-16 7.167-16 16v192c0 8.832 7.169 16 16 16zm80.001 0c8.831 0 15.999-7.168 15.999-16v-192c0-8.832-7.168-16-15.999-16-8.832 0-16.001 7.167-16.001 16v192c.001 8.832 7.169 16 16.001 16z"}})])
          )
        }
      }
    